import { CSSProperties } from "react";
import { XCard } from "~/jsx/components/design";
import { useSelection } from "~/jsx/context/SelectionContext";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes } from "~/jsx/theme";

export const XHand = ({ style }: { style?: CSSProperties }) => {
  const { onCardClickFactory } = useActions();
  const { card: selectedCard } = useSelection();
  const viewingPlayer = useViewingPlayerOpt();
  if (!viewingPlayer) return null;
  const { hand } = viewingPlayer;

  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        justifyContent: "center",
        ...style,
      }}
    >
      {hand.pile.map((card) => {
        const onClick = onCardClickFactory(card);
        const isSelected = card === selectedCard;
        return (
          <XCard
            onClick={onClick}
            key={card.id}
            card={card}
            width={Sizes.cardWidths.normal}
            isSelected={isSelected}
          />
        );
      })}
    </div>
  );
};
